export const apiConstants = {
  url: "/api/customer",
  company: "/api/company"
};
